import createImageProps from "../image/createImageProps";
import type { VideoProps } from "@bmi-digital/components/media";
import type { Theme } from "@mui/material/styles";
import type { Props } from "./types";

const createVideoProps = (videoData: Props, theme: Theme): VideoProps => {
  const {
    label,
    subtitle,
    videoUrl,
    videoRatio,
    previewMedia,
    defaultYouTubePreviewImage,
    layout,
    className,
    "data-testid": dataTestId
  } = videoData;

  const { height = 0, width = 0 } = videoRatio || {};

  const previewImageSource =
    (previewMedia && createImageProps(previewMedia, theme)) ||
    defaultYouTubePreviewImage;

  return {
    label,
    subtitle,
    videoUrl,
    embedHeight: height,
    embedWidth: width,
    previewImageSource,
    className,
    layout: layout || "dialog",
    "data-testid": dataTestId,
    dataGTM: {
      id: "cta-click--video-youtube",
      label: `${videoUrl}-${label}`,
      action: "Play"
    }
  };
};

export default createVideoProps;
